export default __webpack_public_path__ + "static/media/Flyto_background.29fa5caa.png";